export default __webpack_public_path__ + "static/media/Blog15.47765d37.png";